import SearchHelper from '../../helpers/SearchHelper'
import Utils from '../../utilities/Utils'
import request from './request'

export default class ExpensesController {
  static getExpenses(workspaceId: string, params: object) {
    return request(`/api/workspaces/${workspaceId}/expenses?${SearchHelper.getQueryString(params)}`)
  }

  static requestExport(workspaceId: string, year: number, quarter: number, bookingStatus: 'all' | 'booked' | 'unbooked') {
    return request(`/api/workspaces/${workspaceId}/expenses/export?${Utils.encodeQueryData({ year, quarter, booking_status: bookingStatus })}`)
  }

  static downloadUrl(workspaceId: string, expenseId: string) {
    return `/api/workspaces/${workspaceId}/expenses/${expenseId}/download`
  }
}
